
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { LoaderBusService } from '../loader-bus/loader-bus.service';

/**
 * An HTTP interceptor that updates the state of the `loader-hub` service's HTTP channel.
 */
@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
    /** @ignore */
    constructor (private _loader: LoaderBusService) { }

    /**
   * When a request is intercepted, the interceptor initially toggles the `loader-hub`'s `http` state to true,
   * and toggle it back false when all activity is complete, regardless of success or failure.
   */
    intercept (req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req)
            .pipe(
                map((event) => {
                    this._loader.setHttpStatus(true);
                    return event;
                }),
                catchError((error) => observableThrowError(error)),
                finalize(() => {
                    this._loader.setHttpStatus(false);
                })
            );
    }
}
